import { Separator } from '@workspace/ui/components/separator'
import { Switch } from '@workspace/ui/components/switch'
import { Mail } from 'lucide-react'
import type { UserPreferences } from './types'

export interface UserPreferencesViewProps {
  preferences: UserPreferences
  onEmailSubscribedChange: (value: boolean) => void
  /** Width of the page column; the default is the wide one. */
  widthClassName?: string
}

export function UserPreferencesView({
  preferences,
  onEmailSubscribedChange,
  widthClassName = 'max-w-6xl',
}: UserPreferencesViewProps) {
  return (
    <div className={`mx-auto ${widthClassName} py-2`}>
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">Preferences</h1>
      <p className="mt-1 text-sm text-muted-foreground">Manage your personal preferences</p>

      <section className="mt-6">
        <div className="overflow-hidden rounded-xl border border-border bg-card/30">
          <div className="flex items-center gap-2.5 px-5 py-4">
            <Mail className="size-4 text-muted-foreground" />
            <h2 className="text-sm font-semibold text-foreground">Email Preferences</h2>
          </div>
          <Separator />
          <div className="flex items-center justify-between px-5 py-4">
            <div>
              <p className="text-sm font-medium text-foreground">Automated emails</p>
              <p className="text-xs text-muted-foreground">
                Receive onboarding reminders and activity notifications
              </p>
            </div>
            <Switch
              checked={preferences.emailSubscribed}
              onCheckedChange={onEmailSubscribedChange}
            />
          </div>
        </div>
      </section>
    </div>
  )
}
